import React, { type ReactNode } from 'react';

import { type LinkProps } from 'react-router-dom';

import { YatCombo } from '@pkg/assets/brand';

import { BrandLink, HeaderWrapper } from './styles';

export interface HeaderProps {
    children: ReactNode;
}

export function Header({ children }: HeaderProps) {
    return <HeaderWrapper>{children}</HeaderWrapper>;
}

interface BrandProps {
    to?: LinkProps['to'];
    ariaLabel?: string;
}

function Brand({ to = '/', ariaLabel }: BrandProps) {
    return (
        <BrandLink to={to} aria-label={ariaLabel}>
            <YatCombo />
        </BrandLink>
    );
}

Header.Brand = Brand;
